/* eslint-disable no-async-promise-executor */
/**
 * 获取用户信息
 */
import { userapi } from '@/apis/api2';

let userInfo = null;

// 获取用户信息，作为登录态判断的必要条件，前端cookie中存放的token不再作为判断登录态的依据
export const getUserInfo = async () => new Promise(async (resolve) => {
    if (userInfo) {
        return resolve(userInfo);
    }

    try {
        const res = await userapi.getProfile();
        const { retCode, ret_code, result } = res || {};

        if ((retCode === 0 || ret_code === 0) && result) {
            userInfo = result;
            return resolve(result);
        }
        return resolve(userInfo);
    } catch (error) {
        console.log('getProfile', error);
        return resolve(userInfo);
    }
});
